import React from 'react';
export const Check = () => {
    return (
        <svg
            height="16"
            width="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
            role="img"
            aria-hidden="true"
        >
            <path
                d="M5.38 12.83a.78.78 0 0 1-.5-.19L.59 8.85l.33-.37a1 1 0 0 1 1.42-.09l3 2.62 8.44-9.75a1 1 0 0 1 1.41-.1l.38.33L6 12.57a.74.74 0 0 1-.52.25l-.1.01Z"
                fill="currentColor"
                fill-rule="evenodd"
            ></path>
        </svg>
    );
};
